import Backbone from 'backbone'

var Organization = Backbone.Model.extend({

	section: 'organizations',
	domainType: 'organization',
	urlRoot: 'api/organizations',

	isDatasetCopy() {
		return !!this.get('templateId') && !!this.get('datasetFieldId')
	},

	isTreeCopy() {
		return !!this.get('templateId') && !!this.get('templateRootId')
	},

	isSingleCopy() {
		return !!this.get('templateId') && !this.get('templateRootId')
	},

	isCopy() {
		return this.isDatasetCopy() || this.isTreeCopy() || this.isSingleCopy()
	},

	isTemplate() {
		return this.get('isTemplate')
	},

	isDatasetTemplate() {
		return this.isTemplate() && !!this.get('datasetFieldId')
	},

	isTreeTemplate() {
		return this.isTemplate() && !!this.get('rootTemplateRootId')
	},

	isSingleTemplate() {
		return this.isTemplate() && !this.get('rootTemplateRootId')
	}

})

export default Organization

Organization.__filename__ = 'organizations/organization.js'
